import * as React from "react";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { formatDate } from "./api";
import { statusChip } from "./CampaignsTab";
import { ARMS, CampaignCohortCounts, foldCounts, NO_COHORT, PanelArmCounts, Series, share, sum } from "./cohortOverview";

const mix = (counts: Record<string, number> = {}): string =>
  Object.entries(counts)
    .map(([cohort, n]) => `${cohort} ${n}`)
    .join(", ") || "None";

export const CampaignCohortTable: React.FC<{ campaigns: CampaignCohortCounts[]; series: Series[] }> = ({
  campaigns, series,
}) => (
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell>Campaign</TableCell>
        <TableCell>Status</TableCell>
        {series.map((s) => <TableCell key={s.key} align="right">{s.key}</TableCell>)}
        <TableCell align="right">{NO_COHORT}</TableCell>
        <TableCell align="right">Offers hidden</TableCell>
        <TableCell align="right">Activations</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {campaigns.map((c) => {
        const counts = foldCounts(c.cohorts, series);
        return (
          <TableRow key={c.campaignId}>
            <TableCell>{c.retailerName} · {c.campaignName} (#{c.campaignId})</TableCell>
            <TableCell>{statusChip(c.status)}</TableCell>
            {series.map((s) => <TableCell key={s.key} align="right">{counts[s.key]}</TableCell>)}
            <TableCell align="right">{c.unplaced}</TableCell>
            <TableCell align="right">{c.suppressed}</TableCell>
            <TableCell align="right">{c.activations}</TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  </Table>
);

export const PanelTable: React.FC<{ panels: PanelArmCounts[] }> = ({ panels }) => (
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell>Retailer panel</TableCell>
        <TableCell>Drawn</TableCell>
        {ARMS.map((arm) => <TableCell key={arm.key}>{arm.label} (cohort at draw)</TableCell>)}
        <TableCell align="right">Control share</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {panels.map((p) => {
        const [test, control] = ARMS.map((arm) => sum(Object.values(p.arms[arm.key] ?? {})));
        return (
          <TableRow key={p.panelId}>
            <TableCell>{p.retailerName} v{p.version}</TableCell>
            <TableCell>{formatDate(p.drawnAt)}</TableCell>
            {ARMS.map((arm) => <TableCell key={arm.key}>{mix(p.arms[arm.key])}</TableCell>)}
            <TableCell align="right">{share(control, test + control)}</TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  </Table>
);
